import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const shortcuts = [
    { name: "Projects", path: "/projects/lists", key: "p", icon: "ri-folder-line", color: "text-primary" },
    { name: "Ledger", path: "/ledger/lists", key: "l", icon: "ri-file-list-3-line", color: "text-success" },
    { name: "Customers", path: "/customers/lists", key: "c", icon: "ri-user-line", color: "text-warning" },
    { name: "Employees", path: "/employee/lists", key: "e", icon: "ri-team-line", color: "text-info" },
    { name: "Accounts", path: "/cash-book/lists", key: "a", icon: "ri-bank-line", color: "text-danger" },
];

const HeaderSearch = () => {
    const [query, setQuery] = useState("");
    const [filtered, setFiltered] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const inputRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (query.trim() === "") {
            setFiltered([]);
            setShowDropdown(false);
        } else {
            const f = shortcuts.filter((s) =>
                s.name.toLowerCase().includes(query.toLowerCase())
            );
            setFiltered(f);
            setShowDropdown(f.length > 0);
        }
    }, [query]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (!e.altKey) return;
            const shortcut = shortcuts.find(
                (s) => s.key.toLowerCase() === e.key.toLowerCase()
            );
            if (shortcut) navigate(shortcut.path);
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [navigate]);

    const handleSelect = (path) => {
        navigate(path);
        setQuery("");
        setShowDropdown(false);
    };

    return (
        <div className="header-search position-relative">
            <input
                type="text"
                ref={inputRef}
                className="form-control w-100"
                placeholder="Search..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onFocus={() => setShowDropdown(filtered.length > 0)}
            />

            {showDropdown && (
                <div className="dropdown-menu show position-absolute w-100 mt-1 shadow-sm">
                    {filtered.map((item) => (
                        <button
                            key={item.name}
                            className="dropdown-item d-flex align-items-center"
                            onClick={() => handleSelect(item.path)}
                        >
                            <i className={`${item.icon} fs-18 me-2 ${item.color}`}></i>
                            <span>{item.name}</span>
                            <kbd className="ms-auto">Alt + {item.key.toUpperCase()}</kbd>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default HeaderSearch;
